export default __webpack_public_path__ + "static/media/family.eeb69b7b.svg";